// Client-side "seen onboarding" flag. Deliberately not persisted server-side:
// completing a player profile is a player concern, not an obligation on league
// admins / managers, so there's no per-account "profile completed" state.
var dismissalKey = function (userPk) { return "ls-onboarding-dismissed-".concat(userPk); };
export var isOnboardingDismissed = function (userPk) {
    return localStorage.getItem(dismissalKey(userPk)) === "1";
};
export var dismissOnboarding = function (userPk) {
    return localStorage.setItem(dismissalKey(userPk), "1");
};
